"use client";

import { useCallback, useState } from "react";
import { useAppDispatch } from "../slice/hooks";
import { useHistoryManager } from "../history/useHistoryManager";
import {
  normalizeName,
  useFetchAccessPoint,
  useFetchOrganisation,
  generateProductUrl,
} from "../../lib/util";
import {
  setAccessPoint,
  setAccessPointId,
  setAccessPoints,
  setOrganisation,
} from "../slice/accessOrg-slice";
import { updateFullPath } from "../slice/path-slice";

export function useSwitchingOrgs({ token } = {}) {
  const dispatch = useAppDispatch();
  const { navigateTo } = useHistoryManager();
  const [isSwitching, setSwitching] = useState(false);
  const [error, setError] = useState(null);

  const buildStorePath = (handle, accessPointName) => {
    const cleanAP = normalizeName(accessPointName || "");
    return {
      storePath: `/store/${handle}${accessPointName ? `/${cleanAP}` : ""}`,
      basePath: `/store/${handle}`,
      cleanAP,
    };
  };

  const buildIncomingSlug = (handle, cleanAP) => {
    const url =
      cleanAP === "main-entrance" ? `${handle}` : `${handle}/${cleanAP}`;
    return String(url || "").replace(/^\/+|\/+$/g, "");
  };

  const buildRootedStorePath = (storePath, incoming) => {
    return (
      String(storePath)
        .replace(/(\/?store)(?:\/.*)?$/, "$1")
        .replace(/\/+$/, "") + (incoming ? `/${incoming}` : "")
    );
  };

  const buildNavigationPath = (data, newPath, incoming) => {
    if (data.productId) {
      const productPath = buildRootedStorePath(newPath.storePath, incoming);
      return generateProductUrl(productPath, data);
    }

    if (data.collectionId) {
      const collectionPath = buildRootedStorePath(newPath.storePath, incoming);
      return `${collectionPath}/checkout`;
    }

    return newPath.storePath + (incoming ? `/${incoming}` : "");
  };

  const pickMainAccessPoint = (data, accessPoints) => {
    if (data.accessPointId) {
      const match = accessPoints.find(
        (ap) => ap.accessPointId === data.accessPointId,
      );
      if (data.collectionId && !match) {
        return { accessPointId: data.accessPointId };
      }
      return match || null;
    }

    return accessPoints.length ? accessPoints[0] : null;
  };

  const { mutate: fetchOrganisation } = useFetchOrganisation({
    onError: (err) => {
      console.log(err);
    },
  });

  const { mutate: fetchAccessPoint } = useFetchAccessPoint({
    onError: (err) => {
      // handled in startSwitch
    },
  });

  const startSwitch = useCallback(
    (data = {}) => {
      if (!data || (!data.host && !data.collectionId && !data.productId)) {
        setError(new Error("Invalid data for startSwitch"));
        return;
      }

      setError(null);
      setSwitching(true);
      const { cleanAP, ...newPath } = buildStorePath(
        data.host.handle,
        data.accessPointName,
      );
      const incoming = buildIncomingSlug(data.host.handle, cleanAP);
      const path = buildNavigationPath(data, newPath, incoming);

      // navigateTo(
      // path,
      // {
      // urlData: null,
      // dispatchUrl: false,
      // onNavigate: (navigate) => {
      // if (navigate) {
      // 1) request organisation
      fetchOrganisation(
        {
          orgId: data.host?.profileId,
          token,
        },
        {
          onSuccess: (orgRes) => {
            console.log({ orgRes });
            const organisation = orgRes?.data?.organisation;

            if (!organisation) {
              setError(new Error("Organisation returned empty"));
              setSwitching(false);
              return;
            }

            fetchAccessPoint(
              { orgId: organisation.orgId, token },
              {
                onSuccess: (apRes) => {
                  const newAccessPoints = apRes?.data?.accessPoints || [];
                  const mainAccessPoint = pickMainAccessPoint(
                    data,
                    newAccessPoints,
                  );

                  const snapshot = {
                    organisation,
                    mainAccessPoint,
                    newAccessPoints,
                    accessPointId: data?.accessPointId,
                    ...(data?.productId ? { product: data } : {}),
                    ...(data?.collectionId ? { cart: data } : {}),
                  };
                  if (typeof window !== "undefined") {
                    window.scrollTo({
                      top: 0,
                      behavior: "smooth",
                    });
                  }
                  navigateTo(
                    path,
                    {
                      urlData: snapshot,
                      // debounceMs: 0,
                      // override: true,
                      onNavigate: (navigate) => {
                        if (navigate) {
                          dispatch(setOrganisation(organisation));
                          if (newAccessPoints && newAccessPoints.length > 0) {
                            if (data.accessPointId) {
                              dispatch(setAccessPointId(data.accessPointId));
                            }
                            dispatch(setAccessPoint(mainAccessPoint));
                            dispatch(setAccessPoints(newAccessPoints));
                          }
                        }
                        setSwitching(false);
                      },
                    },
                    false,
                  );
                },
                onError: (err) => {
                  setError(err);
                  setSwitching(false);
                },
              },
            );
          },
          onError: (err) => {
            setError(err);
            setSwitching(false);
          },
        },
      );
      // }
      // },
      // },
      // false,
      // );
    },
    [fetchOrganisation, fetchAccessPoint, navigateTo, dispatch, token],
  );

  return { startSwitch, isSwitching, error };
}

// "use client";

// import { useCallback, useState } from "react";
// import { useAppDispatch } from "../slice/hooks";
// import { useHistoryManager } from "../history/useHistoryManager";
// import {
//   normalizeName,
//   useFetchAccessPoint,
//   useFetchOrganisation,
//   generateProductUrl,
// } from "../../lib/util";
// import {
//   setAccessPoint,
//   setAccessPointId,
//   setAccessPoints,
//   setOrganisation,
// } from "../slice/accessOrg-slice";

// export function useSwitchingOrgs({ token } = {}) {
//   const dispatch = useAppDispatch();
//   const { navigateTo } = useHistoryManager();
//   const [isSwitching, setSwitching] = useState(false);
//   const [error, setError] = useState(null);

//   const buildStorePath = (handle, accessPointName) => {
//     const cleanAP = normalizeName(accessPointName || "");
//     return {
//       storePath: `/store/${handle}${accessPointName ? `/${cleanAP}` : ""}`,
//       basePath: `/store/${handle}`,
//       cleanAP,
//     };
//   };

//   const buildIncomingSlug = (handle, cleanAP) => {
//     const url =
//       cleanAP === "main-entrance" ? `${handle}` : `${handle}/${cleanAP}`;
//     return String(url || "").replace(/^\/+|\/+$/g, "");
//   };

//   const buildRootedStorePath = (storePath, incoming) => {
//     return (
//       String(storePath)
//         .replace(/(\/?store)(?:\/.*)?$/, "$1")
//         .replace(/\/+$/, "") + (incoming ? `/${incoming}` : "")
//     );
//   };

//   const buildNavigationPath = (data, newPath, incoming) => {
//     if (data.productId) {
//       const productPath = buildRootedStorePath(newPath.storePath, incoming);
//       return generateProductUrl(productPath, data);
//     }

//     if (data.collectionId) {
//       const collectionPath = buildRootedStorePath(newPath.storePath, incoming);
//       return `${collectionPath}/checkout`;
//     }

//     return newPath.storePath + (incoming ? `/${incoming}` : "");
//   };

//   const pickMainAccessPoint = (data, accessPoints) => {
//     if (data.accessPointId) {
//       const match = accessPoints.find(
//         (ap) => ap.accessPointId === data.accessPointId,
//       );
//       if (data.collectionId && !match) {
//         return { accessPointId: data.accessPointId };
//       }
//       return match || null;
//     }

//     return accessPoints.length ? accessPoints[0] : null;
//   };

//   const { mutate: fetchOrganisation } = useFetchOrganisation({
//     onError: (err) => {
//       console.log(err);
//     },
//   });

//   const { mutate: fetchAccessPoint } = useFetchAccessPoint({
//     onError: (err) => {
//       // handled in startSwitch
//     },
//   });

//   const startSwitch = useCallback(
//     (data = {}) => {
//       if (!data || (!data.host && !data.collectionId && !data.productId)) {
//         setError(new Error("Invalid data for startSwitch"));
//         return;
//       }

//       setError(null);
//       setSwitching(true);

//       // 1) request organisation
//       fetchOrganisation(
//         {
//           orgId: data.host?.profileId,
//           token,
//         },
//         {
//           onSuccess: (orgRes) => {
//             const organisation = orgRes?.data?.organisation;

//             if (!organisation) {
//               setError(new Error("Organisation returned empty"));
//               setSwitching(false);
//               return;
//             }

//             fetchAccessPoint(
//               { orgId: organisation.orgId, token },
//               {
//                 onSuccess: (apRes) => {
//                   const newAccessPoints = apRes?.data?.accessPoints || [];
//                   const { cleanAP, ...newPath } = buildStorePath(
//                     data.host.handle,
//                     data.accessPointName,
//                   );
//                   const incoming = buildIncomingSlug(data.host.handle, cleanAP);
//                   const path = buildNavigationPath(data, newPath, incoming);
//                   const mainAccessPoint = pickMainAccessPoint(
//                     data,
//                     newAccessPoints,
//                   );

//                   const snapshot = {
//                     organisation,
//                     mainAccessPoint,
//                     newAccessPoints,
//                     accessPointId: data?.accessPointId,
//                     ...(data?.productId ? { product: data } : {}),
//                     ...(data?.collectionId ? { cart: data } : {}),
//                   };

//                   navigateTo(
//                     path,
//                     {
//                       urlData: snapshot,
//                       onNavigate: (navigate) => {
//                         if (navigate) {
//                           setSwitching(false);
//                           if (typeof window !== "undefined") {
//                             window.scrollTo({ top: 0, behavior: "smooth" });
//                           }
//                           dispatch(setOrganisation(organisation));
//                           if (newAccessPoints && newAccessPoints.length > 0) {
//                             if (data.accessPointId) {
//                               dispatch(setAccessPointId(data.accessPointId));
//                             }
//                             dispatch(setAccessPoint(mainAccessPoint));
//                             dispatch(setAccessPoints(newAccessPoints));
//                           }
//                         }
//                       },
//                     },
//                     false,
//                   );
//                 },
//                 onError: (err) => {
//                   setError(err);
//                   setSwitching(false);
//                 },
//               },
//             );
//           },
//           onError: (err) => {
//             setError(err);
//             setSwitching(false);
//           },
//         },
//       );
//     },
//     [fetchOrganisation, fetchAccessPoint, navigateTo, dispatch, token],
//   );

//   return { startSwitch, isSwitching, error };
// }
